var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hub"},[_c('Sidebar',{on:{"route":_vm.handleRoute}}),_c(_vm.currentComponent,{tag:"component",staticClass:"main"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }